// TODO: follow casing conventions for constants
export const BrowseComponents = Object.freeze({
  Browse: 'browse',
  Map: 'map',
  Search: 'search',
  SearchMap: 'searchMap',
});

export const BrowseListingTypeOptions = Object.freeze({
  ImBuying: 'supply',
  ImSelling: 'demand',
  ImBuyingAndSelling: 'supply,demand',
});
export const defaultViewPostTypeOptions = [
  { name: "I'm Buying", value: BrowseListingTypeOptions.ImBuying },
  { name: "I'm Selling", value: BrowseListingTypeOptions.ImSelling },
  {
    name: "I'm Buying & Selling",
    value: BrowseListingTypeOptions.ImBuyingAndSelling,
  },
];

export const SortByOptions = Object.freeze({
  MostRecent: 'Most Recent',
  Nearest: 'Nearest',
  Price: 'Price',
  PriceDescending: 'Price Descending',
});
export const defaultSortByOptionsArray = [
  { name: 'Most Recent', value: SortByOptions.MostRecent },
  { name: 'Nearest', value: SortByOptions.Nearest },
  { name: 'Price: $ - $$$', value: SortByOptions.Price },
  { name: 'Price: $$$ - $', value: SortByOptions.PriceDescending },
];

export const BrowseProductsOrServiceOptions = Object.freeze({
  ProductsAndServices: 'product,service',
  Products: 'product',
  Services: 'service',
});
export const defaultProductsOrServicesOptions = [
  {
    name: 'Products & Services',
    value: BrowseProductsOrServiceOptions.ProductsAndServices,
  },
  { name: 'Products', value: BrowseProductsOrServiceOptions.Products },
  { name: 'Services', value: BrowseProductsOrServiceOptions.Services },
];

export const BrowseCardTypeOptions = Object.freeze({
  ListingsAndStorefronts: 'demand,supply,storefront',
  Listings: 'demand,supply',
  Storefronts: 'storefront',
});
export const defaultCardTypeOptions = [
  {
    name: 'Listings & Storefronts',
    value: BrowseCardTypeOptions.ListingsAndStorefronts,
  },
  { name: 'Listings', value: BrowseCardTypeOptions.Listings },
  { name: 'Storefronts', value: BrowseCardTypeOptions.Storefronts },
];

export const browseStoreName = 'BrowseStore';
export const browseCardsStoreName = 'BrowseCardsStore';
export const searchCardsStoreName = 'SearchCardsStore';

export const getDefaultGoogleMapOptions = _isMobile => {
  const defaultMapOptions = {
    disableDefaultUI: true,
    mapTypeControl: false,
    scaleControl: true,
    zoomControl: true,
    streetViewControl: false,
    fullscreenControl: false,
    mapTypeId: window.google.maps.MapTypeId.ROADMAP,
    mapTypeControlOptions: {
      position: window.google.maps.ControlPosition.LEFT_BOTTOM,
    },
    gestureHandling: 'greedy',
  };
  return defaultMapOptions;
};

export const DEFAULT_BROWSE_FILTER_OPTIONS = {
  sortBy: defaultSortByOptionsArray[0].value,
  states: [],
  cardType: defaultCardTypeOptions[0].value,
  buyingOrSelling: defaultViewPostTypeOptions[2].value,
  productsOrServices: defaultProductsOrServicesOptions[0].value,
};

export const MOBILE_MAP_CONTINENTAL_ZOOM = 3;
export const DESKTOP_MAP_CONTINENTAL_ZOOM = 4;

export const BrowseDropdownListingTypeOptions = Object.freeze({
  ImBuying: 'supply',
  ImSelling: 'demand',
});
export const defaultBrowseDropdownListingTypeOptions = [
  { name: "I'm Buying", value: BrowseDropdownListingTypeOptions.ImBuying },
  { name: "I'm Selling", value: BrowseDropdownListingTypeOptions.ImSelling },
];

export const BrowseDropdownCardTypeOptions = Object.freeze({
  Listings: 'demand,supply',
  Storefronts: 'storefront',
});

export const defaultBrowseDropdownCardTypeOptions = [
  { name: 'Listings', value: BrowseDropdownCardTypeOptions.Listings },
  { name: 'Storefronts', value: BrowseDropdownCardTypeOptions.Storefronts },
];
